import React from 'react';
import AdminLayout from './AdminLayout';
import CustomFieldsTab from '../../components/CustomFieldsTab';

export default function AdminCustomFieldsPage() {
    return (
        <AdminLayout title="Custom Fields" description="Create custom fields for your CRM objects">
            <CustomFieldsTab />
        </AdminLayout>
    );
}
